export default __webpack_public_path__ + "static/media/Group 626054.db673d03.svg";